let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6vKr8")).then(() => parcelRequire('f1u87'));